import { EventDataKey } from "core/analytics/analytics.types";
import {
  getBpxUserAnalyticsParams,
  getContextNameFromUrlBasePath
} from "core/analytics/analytics.utils";
import { APP_NAME } from "core/common-types/app.constants";
import { useCallback } from "react";

import { useAccount } from "@azure/msal-react";
import { useQueryClient } from "@tanstack/react-query";

export const useAccountClaimAnalyticsParams = (): Partial<
  Record<EventDataKey | "userId", string | number | boolean | undefined>
> => {
  const account = useAccount();
  const claims = account?.idTokenClaims;

  return {
    userId: claims?.oid as string,
    tenantId: claims?.bpt as string
  };
};

export const useDefaultAnalyticsParams = () => {
  const queryClient = useQueryClient();
  const claimParams = useAccountClaimAnalyticsParams();

  const appContext = getContextNameFromUrlBasePath();

  const getUserParams = useCallback(
    () => getBpxUserAnalyticsParams(queryClient),
    [queryClient]
  );
  return useCallback(() => {
    const userParams = getUserParams();
    return { ...claimParams, ...userParams, appId: APP_NAME, appContext };
  }, [getUserParams, claimParams, appContext]);
};
